export default {
  label: '技术专家',
  id: '0',
  children: [
    {
      label: '定义',
      id: '0-1',
      children: [
        {
          label: '特定领域（如AI、安全）的深度专精者。',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '职责',
      id: '0-2',
      children: [
        {
          label: '在特定领域拥有深入知识和专业技能，解决复杂技术问题，提供技术指导。',
          id: '0-2-1',
        },
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备深厚的技术背景，能够制定技术战略，推动技术创新。',
          id: '0-3-1',
        },
      ],
    },
    {
      label: '职业发展',
      id: '0-4',
      children: [
        {
          label: '通常在8年以上经验后成为架构师或技术经理。',
          id: '0-4-1',
        },
      ],
    },
    {
      label: '薪资水平',
      id: '0-5',
      children: [
        {
          label: '月薪在25,000-50,000元之间，年薪可达50-100万元。',
          id: '0-5-1',
        },
      ],
    },
  ],
};